export const allergyOptions = [
  {label: 'Food', value: 'Food'},
  {label: 'Drug', value: 'Drug'},
  {label: 'Latex', value: 'Latex'},
  {label: 'Other', value: 'Other'},
  {label: 'None Known', value: 'None Known'},
]

export const codeStatusOptions = [
  {label: 'DNR', value: 'CNR'},
  {label: 'Full Code', value: 'Full Code'},
]

export const infoSourceOptions = [
  {label: 'Patient', value: 'Patient'},
  {label: 'Family', value: 'Family'},
  {label: 'Other', value: 'Other'},
]

export const precautionOptions = [
  {label: 'Standard', value: 'Standard'},
  {label: 'Contact', value: 'Contact'},
  {label: 'Droplet', value: 'Droplet'},
  {label: 'Airborne', value: 'Airborne'},
  {label: 'Other', value: 'Other'},
  {label: 'Falls', value: 'Falls'}, 
]

export const medicationOptions = [
  {label: 'Medication Reconciliation completed', value: 'Medication Reconciliation completed'},
  {
    label: 'Reviewed medication profile with patient and/or family',
    value: 'Reviewed medication profile with patient and/or family',
  },
]

export const woundsOptions = [
  {label: 'Infected Surgical Dehiscence', value: 'Infected Surgical Dehiscence'},
  {label: 'Stage III or IV pressure', value: 'Stage III or IV pressure'},
  {label: 'WCC Consult', value: 'WCC Consult'},
]

export const alternativeNutritionOptions = [
  {label: 'Enteral', value: 'Enteral'},
  {label: 'TPN/PPN', value: 'TPN/PPN'},
  {label: 'NPO', value: 'NPO'},
]

export const weightdetailsOptions = [
  {label: 'Gained', value: 'Gained'},
  {label: 'Loss', value: 'Loss'},
  { label: 'N/A', value: 'NA' }, 
]

export const weightamountOptions = [
  {label: '5-10', value: '5-10'},
  {label: '11-20', value: '11-20'},
  {label: '>20', value: '>20'},
]

export const dietaryDetailsOptions = [
  {label: 'Albunim', value: 'Albunim'},
  {label: 'Difficulty Chewing', value: 'Difficulty Chewing'},
  {label: 'Difficulty Swallowing', value: 'Difficulty Swallowing'},
  {label: 'Nausea', value: 'Nausea'},
  {label: 'Vomiting', value: 'Vomiting'},
  {label: 'Diarrhea', value: 'Diarrhea'},
  {label: 'Constipation', value: 'Constipation'},
  {label: 'Renal Failure', value: 'Renal Failure'},
  {label: 'Cancer', value: 'Cancer'},
  {label: 'Liver Failure', value: 'Liver Failure'},
  {label: 'Uncontrolled Diabetes', value: 'Uncontrolled Diabetes'},
  {label: 'COPD', value: 'COPD'},
  {label: 'S/P Surgery', value: 'S/P Surgery'},
]

export const initialStateForm1 = {
  clientId: '',
  assessmentDate: '',
  allergies: [],
  otherAllergies: '',
  codeStatus: '',
  infoSource: '',
  otherInfoSource: '',
  precautions: '',
  otherPrecautions: '',
  t: '',
  r: '',
  p: '',
  bp: '',
  height: '',
  weight: '',
  medications: [],
  wounds: '',
  alternativeNutrition: '',
  weightdetails: '',
  weightamount: '',
  dietaryDetails: [],
}

// Form 2 Constants
export const leisureInterestOptions = [
  {label: 'Sports', value: 'Sports'},
  {label: 'Music', value: 'Music'},
  {label: 'Church', value: 'Church'},
  {label: 'Crafts', value: 'Crafts'},
  {label: 'TV', value: 'TV'},
]

export const yesNoOptions = [
  {label: 'Yes', value: 'true'},
  {label: 'No', value: 'false'},
]
export const yesNoOption = [
  {label: 'Yes', value: 'true'},
  {label: 'No', value: 'false'},
  {label: 'N/A',value: 'na'}
]

export const responseOptions = [
  {label: 'Opens spontaneously', value: 'Opens spontaneously'},
  {label: 'Opens to verbal commands', value: 'Opens to verbal commands'},
  {label: 'Opens to pain', value: 'Opens to pain'},
  {label: 'No response', value: 'No response'},
]

export const motorResponseOptions = [
  {label: 'Obeys/follows simple commands', value: 'Obeys/follows simple commands'},
  {label: 'Localize pain', value: 'Localize pain'},
  {label: 'Abnormal flexion (decorticate)', value: 'Abnormal flexion (decorticate)'},
  {label: 'Abnormal extension (decerebrate)', value: 'Abnormal extension (decerebrate)'},
  {label: 'Flaccid', value: 'Flaccid'},
]

export const verbalResponseOptions = [
  {label: 'Is oriented and converses', value: 'Is oriented and converses'},
  {label: 'Is disoriented but converses', value: 'Is disoriented but converses'},
  {label: 'Uses appropriate words', value: 'Uses appropriate words'},
  {label: 'Makes incomprehensible sounds', value: 'Makes incomprehensible sounds'},
  {label: 'No response', value: 'No response'},
]

export const affectOptions = [
  {label: 'Appropriate', value: 'Appropriate'},
  {label: 'Irregular', value: 'Irregular'},
  {label: 'Anxious', value: 'Anxious'},
  {label: 'Depressed', value: 'Depressed'},
  {label: 'Calm', value: 'Calm'},
  {label: 'Agitated', value: 'Agitated'},
  {label: 'Other', value: 'Other'},
]

export const hearingVisionGagSpeechOptions = [
  {label: 'Normal', value: 'Normal'},
  {label: 'Abnormal', value: 'Abnormal'},
]

export const initialStateForm2 = {
  leisureInterest: [],
  socialActivities: '',
  copingSkills: '',
  abuseHistory: '',
  selfHarm: '',
  culturalPractices: '',
  spiritualPractices: '',
  etohConsumption: '',
  drugAbuse: '',
  caffeineIntake: '',
  tobaccoUse: '',
  cessationEducation: '',
  otherPsychosocial: '',
  response: '',
  motorResponse: '',
  verbalResponse: '',
  affect: '',
  otherAffect: '',
  hearing: '',
  vision: '',
  gagReflex: '',
  speech: '',
}

// Form 3 Constants
export const regularOptions = [
  {label: 'Apical', value: 'regularApical'},
  {label: 'Radial/RT', value: 'regularRadialRT'},
  {label: 'Radial/LT', value: 'regularRadialLT'},
  {label: 'Pedal/RT', value: 'regularPedalRT'},
  {label: 'Pedal/LT', value: 'regularPedalLT'},
]

export const irregularOptions = [
  {label: 'Apical', value: 'irregularApical'},
  {label: 'Radial/RT', value: 'irregularRadialRT'},
  {label: 'Radial/LT', value: 'irregularRadialLT'},
  {label: 'Pedal/RT', value: 'irregularPedalRT'},
  {label: 'Pedal/LT', value: 'irregularPedalLT'},
]

export const strongOptions = [
  {label: 'Apical', value: 'strongApical'},
  {label: 'Radial/RT', value: 'strongRadialRT'},
  {label: 'Radial/LT', value: 'strongRadialLT'},
  {label: 'Pedal/RT', value: 'strongPedalRT'},
  {label: 'Pedal/LT', value: 'strongPedalLT'},
]

export const weakOptions = [
  {label: 'Apical', value: 'weakApical'},
  {label: 'Radial/RT', value: 'weakRadialRT'},
  {label: 'Radial/LT', value: 'weakRadialLT'},
  {label: 'Pedal/RT', value: 'weakPedalRT'},
  {label: 'Pedal/LT', value: 'weakPedalLT'},
]

export const chestPainOptions = [
  {label: 'Present', value: 'true'},
  {label: 'Absent', value: 'false'},
]

export const nailBedsOptions = [
  {label: 'Pink', value: 'Pink'},
  {label: 'Dusky', value: 'Dusky'},
  {label: 'Cyanotic', value: 'Cyanotic'},
  {label: 'Clubbing', value: 'Clubbing'},
]

export const edemaOptions = [
  {label: 'Feet/LE', value: 'FeetLE'},
  {label: 'Hands/UE', value: 'HandsUE'},
  {label: 'Other', value: 'Other'},
]

export const capillaryRefillOptions = [
  {label: 'Feet/LE', value: 'capillaryRefillFeetLE'},
  {label: 'Hands/UE', value: 'capillaryRefillHandsUE'},
  {label: 'Other', value: 'capillaryRefillOther'},
]

export const otherCardiovascularOptions = [
  {label: 'Telemetry', value: 'Telemetry'},
  {label: 'Ted hose', value: 'Ted hose'},
  {label: 'Pacemaker', value: 'Pacemaker'},
  {label: 'SCDs', value: 'SCDs'},
  {label: 'Cardiac Rhythm', value: 'Cardiac Rhythm'},
]

export const clearOptions = [
  {label: 'Clear Left', value: 'clearL'},
  {label: 'Clear Right', value: 'clearR'},
]

export const equalbilaterallyOptions = [
  {label: 'Equal bilaterally Left', value: 'equalbilaterallyL'},
  {label: 'Equal bilaterally Right', value: 'equalbilaterallyR'},
]

export const courseOptions = [
  {label: 'Course Left', value: 'courseL'},
  {label: 'Course Right', value: 'courseR'},
]

export const ralesOptions = [
  {label: 'Rales Left', value: 'ralesL'},
  {label: 'Rales Right', value: 'ralesR'},
]

export const rhonchiOptions = [
  {label: 'Rhonchi Left', value: 'rhonchiL'},
  {label: 'Rhonchi Right', value: 'rhonchiR'},
]

export const wheezeOptions = [
  {label: 'Wheeze Left', value: 'wheezeL'},
  {label: 'Wheeze Right', value: 'wheezeR'},
]

export const pleuralOptions = [
  {label: 'Pleural Left', value: 'pleuralL'},
  {label: 'Pleural Right', value: 'pleuralR'},
]

export const coughOptions = [
  {label: 'Productive', value: 'Productive'},
  {label: 'Non-productive', value: 'Nonproductive'},
  {label: 'None', value: 'None'},
]

export const yesNoOptionsForm3 = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No', value: 'No'},
]

export const initialStateForm3 = {
  // Cardiovascular
  regular: [],
  irregular: [],
  strong: [],
  weak: [],
  chestPain: '',
  chestPainLoc: '',
  nailBeds: '',
  edemafour: [],
  edemafourDetails: '',
  edemathree: [],
  edemathreeDetails: '',
  edematwo: [],
  edematwoDetails: '',
  edemaone: [],
  edemaoneDetails: '',
  capillaryRefill: [],
  capillaryRefillOtherDetails: '',
  capillaryRefillTime: '',
  otherCardiovascular: [],
  cardianRhythmDetails: '',
  // Pulmonary
  clear: [],
  equalbilaterally: [],
  course: [],
  rales: [],
  rhonchi: [],
  wheeze: [],
  pleural: [],
  otherSoundDetails: '',
  cough: '',
  coughColor: '',
  coughQuality: '',
  coughQuantity: '',
  nasalFlaring: '',
  breathShortness: '',
  ett: '',
  ettSize: '',
  o2: '',
  o2Amount: '',
  o2Device: '',
  otherPulmonary: '',
  takenvia: '',
}

// Form 4 Constants
export const bowelPatternsOptions = [
  {label: 'Continent', value: 'Continent'},
  {label: 'Incontinent', value: 'Incontinent'},
  {label: 'Constipation', value: 'Constipation'},
  {label: 'Diarrhea', value: 'Diarrhea'},
  {label: 'Colostomy/Illeostomy', value: 'Colostomy/Illeostomy'},
]

export const bowelSoundsOptions = [
  {label: 'Normal (Normoactive x4 quads)', value: 'Normal'},
  {label: 'Hypoactive', value: 'Hypoactive'},
  {label: 'Hyperactive', value: 'Hyperactive'},
  {label: 'Absent', value: 'Absent'},
]

export const abdomenOptions = [
  {label: 'Soft', value: 'Soft'},
  {label: 'Firm', value: 'Firm'},
  {label: 'Non-tender', value: 'Non-tender'},
  {label: 'Tender', value: 'Tender'},
  {label: 'Guarding', value: 'Guarding'},
  {label: 'Distended', value: 'Distended'},
]

export const experiencingGIOptions = [
  {label: 'Urgency', value: 'Urgency'},
  {label: 'Frequency', value: 'Frequency'},
  {label: 'Dysuria', value: 'Dysuria'},
  {label: 'Pain/Burning with urination', value: 'Pain/Burning'},
  {label: 'Bloody urine', value: 'Bloody'},
  {label: 'Cloudy urine', value: 'Cloudy'},
  {label: 'Foul smelling urine', value: 'Foul smell'},
]

export const bladderOptions = [
  {label: 'Continent', value: 'Continent'},
  {label: 'Incontinent', value: 'Incontinent'},
  {label: 'Anuric', value: 'Anuric'},
  {label: 'Stress incontinence', value: 'Stress incontinence'},
  { label: 'Foley catheter', value: 'Foley catheter' }, 
]

export const initialStateForm4 = {
  // Gastrointestinal
  lastBMdate: '',
  bowelPatterns: '',
  bowelSounds: '',
  abdomen: '',
  abdomenLocation: '',
  // Genitourinary
  experiencingGI: '',
  urineColor: '',
  bladder: '',
  catheterType: '',
  catheterSize: '',
  catheterDate: '',
  catheterChange: '',
  // Musculoskeletal
  equal: [],
  strong: [],
  weak: [],
  paralysis: [],
  spastic: [],
  contracture: [],
  flaccid: [],
  amputation: [],
  bedMobility: '',
  transfers: '',
  gait: '',
  balance: '',
  // Communication/Cognitive
  comprehension: '',
  expression: '',
  cognition: '',
  readingWriting: '',
  // ADL
  grooming: '',
  feeding: '',
  bathing: '',
  dressing: '',
  assistiveDevices: [],
  otherassistiveDevices: '',
  // Skin Assessment
  skinColor: [],
  skintempreture: [],
  otherskinTempDetails: '',
  turgor: '',
  otherTurgorDetails: '',
  skinTexture: '',
  otherskinTextureDetails: '',
  sensory: '',
  moisture: '',
  activity: '',
  mobility: '',
  nutrition: '',
  friction: '',
  skinPrecatuions: '',
  woundTeamNotified: '',
  // Nutrition
  diet: '',
  dietType: '',
  supplements: '',
  howOften: '',
  restricitons: '',
  appetite: '',
  tubeFeeding: '',
  parentalFeeding: '',
  experiencing: [],
  mucosaIntact: '',
  tongueIntact: '',
  dentitionIntact: '',
  otherdetails: '',
} 